import { z } from 'zod';

import { PaymentProps } from '@/features/ui';

import {
  InsuranceSelectionProps,
  DataPreviewProps,
  SmsVerificationProps,
  InsuranceServiceResultProps,
} from '../ui/steps';

import {
  dataPreviewSchema,
  insuranceOrderPreviewModalSchema,
  insuranceSelectionSchema,
  insuranceServiceMergedSchema,
  insuredAddressSchema,
  insuredDataSchema,
  insuredDocumentSchema,
} from './schemas';

export enum InsuranceServiceError {
  AUTH = 'AUTH',
  INSURANCE_PRODUCTS_NO_DATA = 'INSURANCE_PRODUCTS_NO_DATA',
  SMTH_WENT_WRONG = 'SMTH_WENT_WRONG',
  FINANCIAL_INTELLIGENCE = 'FINANCIAL_INTELLIGENCE',
  REQUEST_FAILED = 'REQUEST_FAILED',
  WRONG_TAX_NUMBER = 'WRONG_TAX_NUMBER',
}

export type ServiceProps = InsuranceSelectionProps &
  DataPreviewProps &
  SmsVerificationProps &
  PaymentProps &
  InsuranceServiceResultProps;

export type InsuranceSelectionSchema = z.infer<typeof insuranceSelectionSchema>;
export type InsuredDataSchema = z.infer<typeof insuredDataSchema>;
export type InsuredAddressSchema = z.infer<typeof insuredAddressSchema>;
export type InsuredDocumentSchema = z.infer<typeof insuredDocumentSchema>;
export type DataPreviewSchema = z.infer<typeof dataPreviewSchema>;
export type InsuranceServiceMergedSchema = z.infer<typeof insuranceServiceMergedSchema>;
export type InsuranceOrderPreviewModalSchema = z.infer<typeof insuranceOrderPreviewModalSchema>;
